import React from 'react';
import PropTypes from 'prop-types';
import FilesetPreviewTableContainer from './FilesetPreviewTableContainer';

export default class FilesetPreview extends React.Component {
  static propTypes = {
    accordionsOpen: PropTypes.array.isRequired,
    currentFilesets: PropTypes.object.isRequired,
    datasetId: PropTypes.string.isRequired,
    toggleAccordion: PropTypes.func,
    version: PropTypes.number,
  };

  static defaultProps = {
    toggleAccordion: [],
    version: undefined,
  };

  handleClickFileset = filesetId => () => {
    const { toggleAccordion } = this.props;
    toggleAccordion(filesetId);
  };

  renderFilesets = fileset => {
    const { accordionsOpen } = this.props;
    const isOpen = accordionsOpen.reduce((l, r) => l || r === fileset.id, false);
    return (
      <div key={fileset.id} className="card card-block no-padding">
        <div className="panel panel-default" key={fileset.id}>
          <div className="panel-heading" role="tab" id={fileset.id}>
            <div className="panel-title">
              <div
                data-toggle="collapse"
                data-parent="#accordion"
                onClick={this.handleClickFileset(fileset.id)}
                role="button"
                tabIndex={0}
                aria-expanded={isOpen}
                aria-controls={fileset.id}
                className={isOpen ? 'collapsed single-info panel-active' : 'collapsed single-info'}
              >
                <strong>{fileset.dataFilenamePattern} </strong>
              </div>
            </div>
          </div>
          <div
            id="collapseOne"
            className={isOpen ? 'panel-collapse collapse in' : 'panel-collapse collapse'}
            role="tabpanel"
            aria-labelledby={fileset.id}
            aria-expanded={isOpen}
          >
            {isOpen ? this.renderFilesetTable(fileset) : null}
          </div>
        </div>
      </div>
    );
  };

  renderFilesetTable = fileset => {
    const { datasetId, version } = this.props;

    return (
      <div>
        <FilesetPreviewTableContainer datasetId={datasetId} fileset={fileset} version={version} />
        <br />
      </div>
    );
  };

  render() {
    const { currentFilesets } = this.props;

    return (
      <div>
        {currentFilesets === undefined || currentFilesets.size === 0 ? (
          <p>There are no filesets currently associated with this account.</p>
        ) : (
          <div id="accordion" className="table" role="tablist" aria-multiselectable="true">
            <div className="header dataset-header">
              <div className="th">File Name</div>
            </div>
            {currentFilesets.valueSeq().map(this.renderFilesets)}
          </div>
        )}
      </div>
    );
  }
}
